export default __webpack_public_path__ + "static/media/productThree.7a1be702.jpeg";